import type { MemberTokenScope } from '@hc-frontend/core-context';
import {
  type ClientApplicationContext,
  getClientApplicationContext,
} from '@hc-frontend/core-context';

import type { AuthenticationHook } from '../../hooks/use-authentication/use-authentication.types';

function isCognitoScope(scope: keyof MemberTokenScope): boolean {
  return scope === 'cognito' || scope === 'cognitoAccessToken';
}

export function getMemberTokenClientSide(
  session: AuthenticationHook,
): ClientApplicationContext['getMemberToken'] {
  return async (scope) => {
    const context = getClientApplicationContext(getMemberTokenClientSide);

    if (isCognitoScope(scope)) {
      if (session.status === 'authenticated') {
        return scope === 'cognito'
          ? session.tokenSet.access.value
          : `${session.tokenSet.access.type} ${session.tokenSet.access.value}`;
      }
    }

    context.log({
      context: 'client',
      message: 'noUserFound',
      type: 'error',
    });
    return '';
  };
}
